import React from 'react';
import { Dialog, IconButton, DialogContent, DialogTitle, DialogActions, Typography, Switch, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from 'components/index';
import { CCReportExportData } from './construction-cost-report.type';

interface CCExportDialogProps {
  open: boolean;
  onClose: () => void;
  exportPreferences: Partial<CCReportExportData>;
  setExportPreferences: (preferences: Partial<CCReportExportData>) => void;
  onExport: () => void;
}

const CCExportDialog: React.FC<CCExportDialogProps> = ({ open, onClose, exportPreferences, setExportPreferences, onExport }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Customize Word File</DialogTitle>
      <IconButton onClick={onClose} style={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ paddingTop: 0 }}>
        <Stack spacing={1} pt={1}>
          <Stack direction={'row'} alignItems={'center'}>
            <Switch
              checked={exportPreferences.includeGSF}
              onChange={e => setExportPreferences({ ...exportPreferences, includeGSF: e.target.checked })}
            />
            <Typography variant='body2' fontWeight={'bold'}>
              Include Cost Per Gross SF
            </Typography>
          </Stack>
          <Stack direction={'row'} alignItems={'center'}>
            <Switch
              checked={exportPreferences.includeNSF}
              onChange={e => setExportPreferences({ ...exportPreferences, includeNSF: e.target.checked })}
            />
            <Typography variant='body2' fontWeight={'bold'}>
              Include Cost Per Net SF
            </Typography>
          </Stack>
          <Stack direction={'row'} alignItems={'center'}>
            <Switch
              checked={exportPreferences.includeUnits}
              onChange={e => setExportPreferences({ ...exportPreferences, includeUnits: e.target.checked })}
            />
            <Typography variant='body2' fontWeight={'bold'}>
              Include Cost Per Unit
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='error' onClick={onClose}>
          Close
        </Button>
        <Button color='primary' onClick={onExport}>
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CCExportDialog;
